// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hI6d","type":"styles_type__aMfPK","choices":"styles_choices__1rq-b"};